import React from "react";
import PropTypes from "prop-types";
import { Box, Col, Flex, FlexRow } from "@edreamsodigeo/prisma-design-system";
import LoginAndFindByBookingReferenceContainer from "../../components/LoginAndFindByBookingReferenceContainer/LoginAndFindByBookingReferenceContainer";
import ManageBookingsBanner from "../../components/ManageBookingsBanner";
import SupportAreaValueProposition from "../../components/SupportAreaValueProposition/SupportAreaValueProposition";
import BookingAuthenticationWrapper from "./components/BookingAuthenticationWrapper";
const MyTripsLoginDesktopContainer = ({
  hasWelcomeSupportAreaBanner,
  userAuthentication,
  incentivizeUserAuthentication
}) => {
  const boxShadow = "0px 4px 16px rgba(0, 0, 0, 0.1)";
  return /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignItems: "start",
    width: hasWelcomeSupportAreaBanner ? "1124px" : "912px",
    margin: "0 auto",
    marginTop: "2x_huge",
    backgroundColor: "neutral.0",
    borderRadius: "regular",
    overflow: "hidden",
    sx: {
      boxShadow
    }
  }, /*#__PURE__*/React.createElement(FlexRow, {
    justifyContent: "space-between",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Flex, {
    width: hasWelcomeSupportAreaBanner ? "772px" : "912px",
    height: "100%",
    justifyContent: "space-between",
    position: "relative",
    backgroundColor: "neutral.0",
    sx: {
      borderRadius: "regular",
      zIndex: "1",
      boxShadow
    }
  }, hasWelcomeSupportAreaBanner ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    px: "2x_big",
    pt: "huge",
    pb: "2x_big",
    flex: "1"
  }, userAuthentication), /*#__PURE__*/React.createElement(BookingAuthenticationWrapper, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ManageBookingsBanner, null), /*#__PURE__*/React.createElement(LoginAndFindByBookingReferenceContainer, {
    incentivizeUserAuthentication: incentivizeUserAuthentication,
    px: "3x_big"
  })))), hasWelcomeSupportAreaBanner && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Flex, {
    mx: "minus_base",
    position: "relative",
    height: "100%",
    sx: {
      zIndex: "0"
    }
  }, /*#__PURE__*/React.createElement(SupportAreaValueProposition, null)))));
};
MyTripsLoginDesktopContainer.propTypes = {
  hasWelcomeSupportAreaBanner: PropTypes.bool,
  userAuthentication: PropTypes.element,
  incentivizeUserAuthentication: PropTypes.element
};
export default MyTripsLoginDesktopContainer;